module.exports = __webpack_public_path__ + "static/img/行业_医疗banner@2x.2f000c1d.png";